import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  // License
  {
    path: '/license/',
    name: 'List License',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['user_docs:read', 'vehicle_docs:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "license" */ '@/router/views/license'),
  },

  {
    path: '/license/reminder',
    name: 'License Reminder',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['license_notification:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "license" */ '@/router/views/license/reminder'),
  },

  {
    path: '/license/reminder/create',
    name: 'Create License Reminder',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['license_notification:update'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "license" */ '@/router/views/license/form'),
  },

  {
    path: '/license/reminder/update/:id',
    name: 'Update License Reminder',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['license_notification:update'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "license" */ '@/router/views/license/form'),
  },

  {
    path: '/license/fleet/import/driver',
    name: 'License Fleet Import Driver',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/license/importDriverDoc'),
  },

  {
    path: '/license/fleet/import/fleet',
    name: 'License Fleet Import Fleet',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/license/importVehicleDoc'),
  },

  // License Setting
  {
    path: '/license/licensesetting/',
    name: 'License Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'b5a-lisensi-pengemudi:read',
            'b5b-lisensi-kendaraan:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'List License' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "license" */ '@/router/views/license/licensesetting'),
  },
]
